<template>
  <app-modal-default class="satellite-view" @close="close" >

    <template v-slot:header>
      {{$ml.get('Satellite View')}} ({{field.name}})
    </template>

    <template v-slot:content>
      <p v-if="field.connectedToVultus && !field.satelliteExpirationDate">
        <b style="color: #E8282F;">{{ $ml.get('Your subscription expired, you can renew it below.') }}</b>
      </p>
      <div v-if="field.connectedToVultus && field.satelliteExpirationDate">

        <SidebarSwitcher
          @input="selectType"
          :items="types"
          :value="selectedType"
        />

          <satellite-selector
            v-model="satellite"
            :items="satellites"
          />

          <template v-if="selectedType == 'ndwi'">

            <model-selector
              v-model="model"
              :items="NDWIModel"
            />
          </template>
          <template v-else-if="selectedType == 'plantHealth'">
            <model-selector
              v-model="model"
              :items="models"
            />
          </template>

          <app-loading
            :loading="loading"
            class="buttons"
          >
            <date-selector
              v-if="activeSub"
              @renderSatelliteImage="$emit('renderSatelliteImage')"
            />
            <!-- <div class="no-images" v-else>
              <p style="color:#E8282F;">{{ $ml.get(`We\'re processing the image, this action can take a few minutes`) }}</p>

            </div> -->

            <nitrogen
              @fetch="fetchAll"
              v-if="selectedType == 'nitrogen'"
              :firstConnection="activeateNitrogenConnection"
            />

            <img
              v-else-if="colorlegend && showDates"
              class="legend"
              :src="colorlegend"
            />

            <app-btn
              @click="checkStatus()"
              style="margin-top:16px;"
              v-if="$store.getters['user/data'].globalRole == 'admin'"
            >
              checkStatus
            </app-btn>

          </app-loading>
          <div class="no-images" v-if="!images && activeSub">
            <p>{{ $ml.get(`We\'re processing the image, this action can take a few minutes`) }}</p>
          </div>
          <div class="no-images" v-if="!activeSub">
            <p>{{ $ml.get(`No subscriptions with this parameters`) }}</p>
          </div>

      </div>

      <connect-field v-else-if="field.shape == 'polygon' && $store.getters['user/data'].globalRole == 'admin'" />
      <p v-else></p>

    </template>
  </app-modal-default>
</template>

<script>
import Zoning from '@/components/satellite/types/Zoning'
import Ndwi from '@/components/satellite/types/Ndwi'
import PlantHealth from '@/components/satellite/types/PlantHealth'
import Nitrogen from '@/components/satellite/types/Nitrogen'
import ConnectField from '@/components/satellite/ConnectField'
import API from '@/api'
import * as turf from '@turf/turf'
import {mapGetters} from 'vuex'
import SidebarSwitcher from '@/components/common/SidebarSwitcher'
import DateSelector from '@/components/satellite/DateSelector'
import SatelliteSelector from '@/components/satellite/SatelliteSelector'
import ModelSelector from '@/components/satellite/ModelSelector'

export default {
  data() {
    return {
      status: null,
      loading: false,
      activeSub: true,
      types: [
        {
          key: 'nitrogen',
          label: 'NITROGEN',
        },
        {
          key: 'plantHealth',
          label: 'PLANT HEALTH',
        },
        {
          key: 'zoning',
          label: 'ZONING',
        },
        {
          key: 'ndwi',
          label: 'NDWI',
        },
      ],
      selectedType: 'nitrogen',
      activeateNitrogenConnection: false,
      showDates : false,
      colorlegend : null,
      satellites: [
        {
          id: 0,
          value: 'sentinel-s2-l1c',
          name: 'sentinel-s2-l1c',
        },
        {
          id: 1,
          value: 'landsat-pds',
          name: 'landsat-pds',
        },
        {
          id: 2,
          value: 'sentinel-s2-l2a',
          name: 'sentinel-s2-l2a',
        },
      ],
      NDWIModel: [
        {
          id: 0,
          value: 'ndvi',
          name: 'ndwi',
        },
      ],
      models: [
        {
          id: 0,
          value: 'ndvi',
          name: 'ndvi',
        },
        {
          id: 1,
          value: 'msavi2',
          name: 'msavi2',
        },
        {
          id: 2,
          value: 'rgb',
          name: 'rgb',
        },
      ],
    }
  },
  methods: {
    fetchAll() {
      this.loading = true;
      this.showDates = false;

      return API.satellite.fetchAll(
        this.selectedType,
        this.field.id,
        this.$store.getters['satellite/satellite'],
        this.$store.getters['satellite/model']
        ).then(res => {
          this.activeSub = true;
          this.$store.commit('satellite/saveNitrogenMeta', null)
          if(this.selectedType == 'nitrogen' && res.data.colorscale) {
            this.$store.commit('satellite/saveNitrogenAmount', res.data.nitrogen);
            this.$store.commit('satellite/saveColorData', res.data.colorscale.colordata);
          }
          if(this.selectedType == 'plantHealth') {
            this.getTimeSeries();
          }
          this.activeateNitrogenConnection = false;
          if(res.data.output.png.length) {
            this.$store.dispatch('satellite/saveImages', res.data.output.png);
            this.loading = false;
            this.showDates = true;
            if(res.data.colorlegend) {
              this.colorlegend = res.data.colorlegend;
            } else {
              this.colorlegend = null;
            }
          } else {
            this.$store.commit('satellite/setImageURL', null);
            this.$store.dispatch('satellite/saveImages', null);
            this.loading = false;
            this.showDates = false;
            this.colorlegend = null;
          }
      })
      .catch(err => {
        if(err.response.data.err == 'No subscriptions with this parameters') {
          this.activeSub = false;
        } else {
          this.activeSub = true;
        }
        if(this.selectedType == 'nitrogen') {
          this.activeateNitrogenConnection = true;
        } else { this.activeateNitrogenConnection = false }
        this.$store.commit('satellite/setImageURL', null);
        this.$store.dispatch('satellite/saveImages', null);
        this.loading = false;
        this.showDates = false;
      })
    },
    getTimeSeries() {
      return API.satellite.getTimeSeries(this.field.id, this.$store.getters['satellite/satellite'])
        .then( res => {
          console.log(res.data);
        })
        .catch(err => {

        });
    },
    getNitrogenColorscale() {
      return API.satellite.getNitrogenColorscale(this.selectedColorData).then(res => {
        // console.log(res.data);
        let data = JSON.parse(res.data);
        // console.log(data.meta);
        if(data.meta) {
          this.$store.commit('satellite/saveNitrogenMeta', data.meta);
        }
      })
    },
    checkStatus() {
      return API.satellite.checkStatus(
        this.selectedType,
        this.field.id,
        this.$store.getters['satellite/satellite'],
        this.$store.getters['satellite/model']
      ).then(res => {
        this.status = res.data.data;
      })
    },
    close() {
      this.$store.dispatch('satellite/close');
    },
    selectType(type) {
      this.selectedType = type;    },
    setImage() {
      if(this.date && this.satellite && this.model && this.selectedType) {
        this.$store.dispatch('satellite/selectImage').then(res => {
          this.$emit('renderSatelliteImage', this.field);
        });
      } else {
        this.$emit('renderSatelliteImage', this.field);
      }
    },
  },
  created() {
    // this.$store.dispatch('satellite/setDates');
    // this.$store.dispatch('satellite/selectModel', this.model);
    // this.$store.dispatch('satellite/selectSatellite', this.satellite);
    this.fetchAll();
  },
  watch: {
    date: function() {
      if(this.selectedType == 'nitrogen' && this.selectedColorData) {
        this.getNitrogenColorscale();
      }
    },
    satellite: function() {
      this.fetchAll();
    },
    model: function() {
      this.fetchAll();
    },
    selectedType: function() {
      this.fetchAll();
    }
  },
  computed: {
    ...mapGetters({
      field: 'satellite/fieldInfo',
      date: 'satellite/date',
      satellite: 'satellite/satellite',
      model: 'satellite/model',
      selectedColorData: 'satellite/colordata',
      images: 'satellite/images',
    }),
  },
  components: {
    SidebarSwitcher,
    Nitrogen,
    Ndwi,
    Zoning,
    PlantHealth,
    ConnectField,
    DateSelector,
    SatelliteSelector,
    ModelSelector,
  }
}
</script>

<style lang="scss" scoped>
.sidebar-switcher {
  padding: 0;

}
.satellite-view {
  &::v-deep .--heading {
    height: auto;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .legend {
    object-fit: contain;
    max-height: 400px;
    // float: left;
  }
  .buttons {
    // min-height: 200px;
    .btn {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.connect {
  p {
    margin-top: 0;
  }
}
</style>
